export default __webpack_public_path__ + "static/media/1242.4a1fe545.png";